// Dependencias generales

import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import home from "./Components/HomePage";
import calculator from "./Components/FormInputs";
import result from "./Components/Result/Result.container";

// Función del router
function AppRouter() {
  return (
    <Router>
      <div className={"site-content"}>
        <Route path="/" exact component={home} />
        <Route path="/calculator" component={calculator} />
        <Route path="/result/:idResult/:diasATrabajar" component={result} />
      </div>
    </Router>
  );
}
export default AppRouter;

